import { EstimateOrderModuleId, InvoiceOrderModuleId, ProductModuleId, SOModuleId } from './../../modules/shared/constants/modules.constant';
import { ParseHelper } from './../../modules/shared/parse.helper';
import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Subject } from 'rxjs/internal/Subject';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ObjectNames } from 'src/app/modules/shared/constants/object.names';
import { LocalDatePipe } from 'src/app/modules/shared/pipes/local-date.pipe';
import { ReportService } from 'src/app/reports/reportService';
import { PermissionService } from 'src/app/service/permission.service';
import { UserService } from 'src/app/service/userservice';
import { SavedSearchNS } from './models/saved-search.models';
import { SavedSearchMessage } from './models/saved-search.static';
import { SavedSearchesService } from './services/saved-searches.service';
import { ChatBotModule } from 'src/app/modules/shared/components/chatbot-modal/model/chatbot.model';

@Component({
    selector: 'app-saved-searches',
    templateUrl: './saved-searches.component.html',
    styleUrls: ['./saved-searches.component.scss'],
    providers: [LocalDatePipe],
    host: {
        '(document:click)': 'onClick($event)',
    },
})
export class SavedSearchesComponent implements OnInit, OnDestroy, AfterViewChecked {
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    menuItems = [];
    globalFilterInput = 'allterritorys';
    isLeftTableHide = false;
    selectedView: 'list' | 'split' | 'select' = "list";
    selectedSearch: SavedSearchNS.ISavedSearchOverview;
    savedSearchResponse: any = null;
    configMenuItemsCM = [];
    listCols1: SavedSearchNS.IColumn[] = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false, moveable: false, dataType: 'number' },
        { field: 'name', header: 'Name', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' }
    ];
    listCols: SavedSearchNS.IColumn[] = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false, moveable: false, dataType: 'number' },
        { field: 'name', header: 'Name', objectNameList: 'name', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'moduleName', header: 'Module', objectNameList: 'routeassignedto', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'templateName', header: 'Template', objectNameList: 'totaldistance', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'assignedPersons', header: 'Access Permission', objectNameList: '', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'createdDate', header: 'Created Date', objectNameList: '', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'createdByUserName', header: 'Created By', objectNameList: '', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'updatedDate', header: 'Updated Date', objectNameList: '', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'updatedByUserName', header: 'Updated By', objectNameList: '', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'description', header: 'Notes', objectNameList: '', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'string' },
    ];
    listColsAll: SavedSearchNS.IColumn[] = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false, moveable: false, dataType: 'number' },
        { field: 'name', header: 'Name', objectNameList: 'name', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'string' },
        { field: 'moduleName', header: 'Module', objectNameList: 'routeassignedto', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'string' },
        { field: 'templateName', header: 'Template', objectNameList: 'totaldistance', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'string' },
        { field: 'assignedPersons', header: 'Access Permission', objectNameList: 'territoryname', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'string' },
        { field: 'createdDate', header: 'Created Date', objectNameList: '', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'createdByUserName', header: 'Created By', objectNameList: '', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'updatedDate', header: 'Updated Date', objectNameList: '', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'updatedByUserName', header: 'Updated By', objectNameList: '', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'description', header: 'Notes', objectNameList: 'territoryname', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'string' },
    ];

    savedSearchesList: SavedSearchNS.ISavedSearch[] = [];
    noSearchesFindOrLoadingText = 'No Saved Searches Found.';
    savedSearchAddViewEditHeader: 'Add Saved Search' | 'View Saved Search' | 'Edit Saved Search';
    noColFindOrLoadingText = 'No Data Found.';
    pageSize: number = 15;

    gridState: any = {};
    totalRecords: number = 0;
    tableShowMore: number[] = [15, 30, 50, 100];
    first: number = 0;
    searchControl = new FormControl();
    moduleSearchValue: string = '';
    selectedTabIndex: number = 0;

    isActive: boolean = true;
    showFloatHeader: boolean = false;
    refreshSavedSearch: boolean = false;
    openColumnSettings: boolean = false;
    exportSavedSearch: boolean = false;

    //Saved Search Add Edit
    displayAddEditDialog: boolean = false;
    savedSearchCopy: boolean = false;
    savedSearchViewOnly: boolean = false;
    savedSearchEditId: number = null;
    savedSearchDetails: SavedSearchNS.ISavedSearchOverview = null;

    scrHeight1: any;
    scrHeight2: any;

    /** Predict Forecast Permission*/
    predictForecastPermission: boolean = false;

    //chat
    savedSearchAnalyticsPermission: boolean = false;
    title = 'chat-ui';
    //@ViewChild('container') container;
    @ViewChild('chatListContainer') list?: ElementRef<HTMLDivElement>;
    chatInputMessage: string = "";
    sender = {
        id: 1,
        profileImageUrl: 'https://cdn.pixabay.com/photo/2017/07/18/23/23/user-2517433_960_720.png'
    }

    receiver = {
        id: 2,
        profileImageUrl: 'https://cdn.pixabay.com/photo/2017/07/18/23/23/user-2517433_960_720.png'
    }

    chatMessages: {
        user: any,
        message: string
    }[] = [
            {
                user: this.receiver,
                message: "hi, How are you?"
            },
        ];
    showEmojiPicker = false;
    sets = [
        'native',
        'google',
        'twitter',
        'facebook',
        'emojione',
        'apple',
        'messenger'
    ]
    set = 'twitter';
    suggestions = [
        {
            id: 1, name: "suggestions", children: [
                { id: 1, name: "What is the most common industry?" },
                { id: 2, name: "What is the average estimated annual revenue?" },
                { id: 3, name: "Show me a barplot of lead types" },
            ]
        }
    ];

    /* Permission */
    readPermission: boolean;
    writePermission: boolean;
    editPermission: boolean;
    deletePermission: boolean;
    exportPermission: boolean;

    //report
    displayAddReportDialog: boolean = false;
    reportMenus = [];
    reportForm: FormGroup;
    //predict
    displayPredict = false;

    //add to list
    displayAddToList = false;
    displayAddedList = false;


    constructor(
        public userService: UserService,
        private fb: FormBuilder,
        private appMainService: AppMainService,
        public app: AppMainComponent,
        private confirmationService: ConfirmationService,
        private savedSearchesService: SavedSearchesService,
        private localDatePipe: LocalDatePipe,
        private messageService: MessageService,
        private permissionService: PermissionService,
        private reportService: ReportService,
    ) { }

    ngOnInit(): void {
        this.prepareReportForm();
        this.getScreenSize();
        this.searchSaveSearches();
        this.setPermissions();
    }

    setPermissions(): void {
        const userPermissions = this.permissionService.getPermissionData();

        if (userPermissions.length) {
            let savedSearchAnalyticsPermission = userPermissions.find(obj => obj.objectName === ObjectNames.SavedSearchAnalytics);

            if (savedSearchAnalyticsPermission?.permissions) {
                savedSearchAnalyticsPermission = savedSearchAnalyticsPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);

                const readPermission = savedSearchAnalyticsPermission && (savedSearchAnalyticsPermission[0].permissionId == 1 && savedSearchAnalyticsPermission[0].statusId == 1);
                const writePermission = savedSearchAnalyticsPermission && (savedSearchAnalyticsPermission[1].permissionId == 2 && savedSearchAnalyticsPermission[1].statusId == 1);
                const editPermission = savedSearchAnalyticsPermission && (savedSearchAnalyticsPermission[2].permissionId == 3 && savedSearchAnalyticsPermission[2].statusId == 1);
                this.savedSearchAnalyticsPermission = (readPermission || writePermission || editPermission);
            }
        }

        if (userPermissions.length) {
            const userPermission = userPermissions.find(obj => obj.objectName === ObjectNames.SavedSearch);

            const modulePermission = userPermission ? userPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1) : null;

            this.readPermission = modulePermission && (modulePermission[0].permissionId == 1 && modulePermission[0].statusId == 1);
            this.writePermission = modulePermission && (modulePermission[1].permissionId == 2 && modulePermission[1].statusId == 1);
            this.editPermission = modulePermission && (modulePermission[2].permissionId == 3 && modulePermission[2].statusId == 1);
            this.deletePermission = modulePermission && (modulePermission[3].permissionId == 4 && modulePermission[3].statusId == 1);
        }

        if (userPermissions.length) {
            let predictForecastPermission = userPermissions.find(obj => obj.objectName === ObjectNames.PREDICT_FORECAST);
            let importExportPermission = userPermissions.find(obj => obj.objectName === ObjectNames.IMPORT_EXPORT);
            if (predictForecastPermission?.permissions) {
                predictForecastPermission = predictForecastPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);

                const readPermission = predictForecastPermission && (predictForecastPermission[0].permissionId == 1 && predictForecastPermission[0].statusId == 1);
                const writePermission = predictForecastPermission && (predictForecastPermission[1].permissionId == 2 && predictForecastPermission[1].statusId == 1);
                const editPermission = predictForecastPermission && (predictForecastPermission[2].permissionId == 3 && predictForecastPermission[2].statusId == 1);
                this.predictForecastPermission = (readPermission || writePermission || editPermission);
            }
            if (importExportPermission?.permissions) {
                importExportPermission = importExportPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
                this.exportPermission = importExportPermission && (importExportPermission[4].permissionId == 5 && importExportPermission[4].statusId == 1);
            }
        }
        this.buildContextMenu();
    }

    buildContextMenu() {
        this.menuItems = [];
        this.menuItems.push(
            {
                label: 'New',
                icon: 'pi pi-plus',
                visible: this.writePermission,
                command: (event) => this.openNewSavedSearch(),
            },
        );
        //Action Menu
        this.configMenuItemsCM = [];
        this.configMenuItemsCM.push(
            {
                label: 'View',
                icon: 'pi pi-list',
                command: () => {
                    this.onRowSelect(null, 'View');
                }
            },
            {
                label: 'Edit',
                icon: 'pi pi-pencil',
                visible: this.editPermission,
                command: () => {
                    this.onRowSelect(null, 'Edit');
                }
            },
            {
                label: 'Make Copy',
                icon: 'pi pi-copy',
                visible: this.editPermission,
                command: () => {
                    this.onRowSelect(null, 'Copy');
                }
            },
            {
                label: 'Delete',
                icon: 'pi pi-trash',
                visible: this.deletePermission,
                command: () => {
                    // this.deleteSavedSearch(this.selectedSearch);
                    this.onRowSelect(null, 'Delete');
                }
            },
            {
                label: 'Add to Report',
                icon: 'pi pi-plus',
                visible: !this.selectedSearch?.isConvertedToReport,
                command: () => {
                    this.prepareReportForm();
                    this.loadAllReportSections();
                }
            },
            {
                label: 'Remove from Report',
                icon: 'pi pi-trash',
                visible: this.selectedSearch?.isConvertedToReport,
                command: () => {
                    this.removeReport(this.selectedSearch);
                }
            },
            {
                label: 'Add to List',
                icon: 'pi pi-plus',
                visible: (!this.selectedSearch?.isWidgetAvailable && ![ProductModuleId,EstimateOrderModuleId,SOModuleId,InvoiceOrderModuleId].includes(this.selectedSearch?.moduleId)),
                command: () => {
                    this.addToList();
                }
            },
            {
                label: 'View Added List',
                icon: 'pi pi-list',
                visible: this.selectedSearch?.isWidgetAvailable,
                command: () => {
                    this.viewAddedList();
                }
            },
        );
    }

    //#region ***Add To Reports***
    prepareReportForm() {
        this.reportForm = this.fb.group({
            name: ["", [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
            route: ["savedsearch-report"],
            savedSearchId: [null],
            parentId: ["", [Validators.required]],
        })
    }

    loadAllReportSections() {
        let updatedReportMenus: any[] = []
        let obj1 = {
            label: 'General Reports',
            value: '0',
            children: [],
            selectable: false
        }
        let obj2 = {}
        this.appMainService.isShowSpinner('report');
        this.reportService.getAllReportMenus().subscribe(menu => {
            this.reportMenus = [];
            updatedReportMenus = [];
            const reportMenus = menu?.length > 0 ? this.removeEmptyParents(menu) : [];
            for (let c of reportMenus) {
                let childData = [];
                for (let child of c.items) {
                    let eachSub = {
                        label: child.label,
                        value: child.id,
                        children: [],
                        reportType: child.reportType,
                    };
                    childData.push(eachSub);
                }
                let eachData = {
                    label: c.label,
                    value: c.id,
                    children: childData,
                    reportType: c.reportType,
                }
                this.reportMenus.push(eachData);
            }
            this.reportMenus.forEach((item) => {
                item.reportType != "finance_reports" ? obj1.children.push(item) : obj2 = { ...item, selectable: false }
            })
            updatedReportMenus.push(obj1, obj2);
            this.reportMenus = [...updatedReportMenus];
            this.appMainService.isHideSpinner('report');
            this.displayAddReportDialog = true;
        })
    }

    removeEmptyParents(data: any[]): any[] {
        return data.map(report => {
            // Filter out parent items without any child items
            report.items = report.items.filter(item => item.items && item.items.length > 0);

            // Recursively apply the function for remaining parent items
            report.items.forEach(item => {
                if (item.items && item.items.length > 0) {
                    item = this.removeEmptyParents([item])[0];
                }
            });

            return report;
        }).filter(report => report.items.length > 0);
    }

    saveReportData(value) {
        this.appMainService.isShowSpinner('savereport');
        value.savedSearchId = this.selectedSearch?.id;
        value.parentId = value.parentId?.value;
        this.reportService.addtoReport(value).then(() => {
            this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Report added successfully...",
            });
            this.displayAddReportDialog = false;
            this.selectedSearch.isConvertedToReport = true;
            this.buildContextMenu();
            this.appMainService.isHideSpinner('savereport')
        })
            .catch((error) => {
                this.appMainService.isHideSpinner('savereport')
                this.messageService.add({
                    severity: "error",
                    summary: "Failed to add report",
                    detail: error?.error?.Message||"Error occurred while saving data...",
                });
            });
    }

    removeReport(selectedSearch: SavedSearchNS.ISavedSearchOverview) {
        this.confirmationService.confirm({
            message: SavedSearchMessage.removeReportconfirmationMessage,
            header: SavedSearchMessage.removeHeader,
            icon: SavedSearchMessage.deleteCircleIcon,
            accept: () => {
                this.appMainService.isShowSpinner('removeReport')
                this.reportService.removeSavedSearchReport(selectedSearch.id)
                    .pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response) => {
                        this.appMainService.isHideSpinner('removeReport')
                        this.selectedSearch.isConvertedToReport = false;
                        this.buildContextMenu();
                        this.messageService.add({ severity: SavedSearchMessage.success.toLowerCase(), summary: SavedSearchMessage.success, detail: SavedSearchMessage.savedSearchRemoveReportSuccessMsg });
                    },
                        err => {
                            this.appMainService.isHideSpinner('removeReport')
                        });
            },
            reject: () => {
            }
        });
    }

    //#endregion ***Add To Report End***

    //#region  ***Save New Saved-Searches***
    openNewSavedSearch() {
        this.savedSearchEditId = null;
        this.savedSearchDetails = null;
        this.savedSearchCopy = false;
        this.savedSearchViewOnly = false;
        this.displayAddEditDialog = true;
    }

    openEditViewSavedSearch(addEditType: string, selectedSavedSearch: SavedSearchNS.ISavedSearchOverview) {
        this.savedSearchEditId = selectedSavedSearch.id;
        this.savedSearchDetails = selectedSavedSearch;
        this.savedSearchViewOnly = (addEditType=='View') as boolean;
        this.savedSearchCopy = (addEditType=='Copy') as boolean;
        this.displayAddEditDialog = true;
    }

    savedSearchUpdated(savedSearchNewData: SavedSearchNS.UpdateSavedSearches) {
        if (this.selectedSearch.statusId == savedSearchNewData.statusId && this.selectedView == 'split') {
            this.onRowSelect(this.selectedSearch, 'Select');
        }
        else {
            this.onRowUnselect(this.selectedSearch);
        }
    }

    closeSavedSearchDialog() {
        this.savedSearchEditId = null;
        this.savedSearchDetails = null;
        this.savedSearchViewOnly = false;
        this.savedSearchCopy = false;
        this.displayAddEditDialog = false;
    }

    loadSavedSearchList() {
        this.getSavedSeachList(1, this.pageSize);
    }

    //#endregion ***Save New Saved-Searches***

    //#region  *******On Select SavedSearch***************
    onRowSelect(event: any, addEditType: 'Select' | 'View' | 'Edit' | 'Copy' | 'Delete' | 'None') {
        this.selectedTabIndex = 0;
        this.savedSearchResponse = null;
        if (event) {
            this.listCols = this.listCols1;
            this.selectedView = 'split';
        }
        if (this.selectedSearch) {
            this.buildContextMenu();
            this.appMainService.isShowSpinner('getSavedSearchById');
            this.savedSearchesService.getSavedSearchById(this.selectedSearch.id).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((resp) => {
                this.appMainService.isHideSpinner('getSavedSearchById');
                this.savedSearchResponse = ParseHelper.DeepCopy(resp);
                this.selectedSearch.savedSearchRuleRequest = this.getViewRuleRequest(resp.savedSearchRule);
                this.selectedSearch.oldCreatedDate = resp?.createdDate || this.selectedSearch.createdDate;
                this.selectedSearch.savedSearchUserPermission = resp.savedSearchUserPermission;
                this.selectedSearch.moduleId = resp?.moduleId;
                this.selectedSearch.channelId = resp?.channelId;
                this.selectedSearch.accountChannelId = resp?.accountChannelId;
                this.selectedSearch.isCombinational = resp?.isCombinational||false;
                this.selectedSearch.ruleCombination = resp?.ruleCombination||false;
                if(resp?.savedSearchColumnSetting && resp?.savedSearchColumnSetting.length > 0){
                    this.selectedSearch.savedSearchColumnSetting = JSON.parse(resp?.savedSearchColumnSetting?.find((x: any) => x.statusId == 1).value ?? []);
                }
                const mainModule: SavedSearchNS.SavedSearchRuleRequest = this.selectedSearch.savedSearchRuleRequest.find(x => x.isMainModule == true);
                if (mainModule) {
                    if (!resp?.moduleId) {
                        this.selectedSearch.moduleId = mainModule.objectId;
                        this.selectedSearch.accountChannelId = mainModule.accountChannelId;
                    }
                    if (!this.selectedSearch?.channelId) {
                        this.selectedSearch.channelId = mainModule.templateId;
                    }
                }

                this.selectedSearch.objectId = this.selectedSearch.moduleId;
                this.selectedSearch.templateId = this.selectedSearch.channelId;

                //View/Edit
                if (addEditType == 'View' || addEditType == 'Edit' || addEditType == 'Copy') {
                    this.openEditViewSavedSearch(addEditType, this.selectedSearch);
                }
                else if (addEditType == 'Delete') {
                    this.deleteSavedSearch(this.selectedSearch);
                }
            },
                error => {
                    this.appMainService.isHideSpinner('getSavedSearchById');
                });
        }
    }

    getViewRuleRequest(savedSearchRule: any[]): SavedSearchNS.SavedSearchRuleRequest[] {
        let ruleRequest: SavedSearchNS.SavedSearchRuleRequest[] = [];
        if (savedSearchRule) {
            savedSearchRule.forEach(element => {
                if (element?.dataType == 'Enum') {
                    if (element?.criteria?.toLowerCase() == 'territoryname') {
                        element.valuesJson = JSON.parse(element?.values[0] || 'null');
                    }
                }
                else if (element?.dataType == 'Distance') {
                    element.valuesJson = JSON.parse(element?.values[0] || 'null');
                }
                else {
                    element.valuesJson = null;
                }
                ruleRequest.push(element);
            });
        }
        if (ruleRequest) {
            ruleRequest = ruleRequest.sort((a, b) => (a.sequenceOrder > b.sequenceOrder) ? 1 : -1);
        }
        return ruleRequest;
    }

    onRowUnselect(event: any) {
        this.selectedSearch = null;
        this.listCols = this.listColsAll;
        this.selectedView = 'list';
        this.selectedTabIndex = 0;
        this.isLeftTableHide = false;
    }

    getSavedSearchListByFilter(event: LazyLoadEvent): void {
        if (!event.sortField && !event.filters) {
            if (event.first == 0 && event.rows == 15) {
                this.getSavedSeachList(1, 15);
                return;
            }
        }

        const pageSize: number = event.rows;
        const pageNumber: number = (event.first / event.rows) + 1;
        //if sort exist
        if (event.sortField) {
            const temp = {
                field: event.sortField,
                order: event.sortOrder
            }
            this.gridState['sort'] = temp;
        }
        //if column filter exist
        if (event.filters) {
            this.onFilterChange(event);
        }

        this.getSavedSeachList(pageNumber, pageSize);
    }

    onFilterChange(event: LazyLoadEvent): void {
        const filters = [];
        for (const filterName in event.filters) {
            filters.push({
                field: filterName,
                value: event.filters[filterName].value
            });
        }
        this.gridState['filters'] = filters
    }

    //SavedSearch Table List
    getSavedSeachList(pageNumber: number, pageSize: number): void {
        let searchValue = this.globalFilterInput.trim() ? this.globalFilterInput.trim() : '';
        const options: any = {};

        // apply field Filter
        if (this.gridState && this.gridState.filters && this.gridState.filters.length) {
            const filterColumns = [];
            this.gridState.filters.map(columnObj => {
                filterColumns.push(columnObj.field);
            });
            searchValue = this.gridState.filters && this.gridState.filters[0] && this.gridState.filters[0].value ? this.gridState.filters[0].value : '';
            options.filter = {
                field: filterColumns.join(','),
                value: searchValue
            }
        }

        // apply sorting
        if (this.gridState && this.gridState.sort) {
            options.sort = {
                SortBy: this.gridState.sort.field,
                IsAscending: this.gridState.sort.order === 1 ? true : false
            }
        }

        options.moduleSearchValue = this.moduleSearchValue.length ? this.moduleSearchValue.trim() : '';

        this.appMainService.isShowSpinner('getSaveSearchList');
        this.savedSearchesService.getAllSavedSearchList(pageNumber, pageSize, this.isActive, options).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response) => {
            let data = response.body == null ? [] : response.body;
            let headers = JSON.parse(response.headers.get('X-Pagination'));
            headers = headers == null ? [] : headers;
            this.totalRecords = headers['TotalCount'] || 0;
            this.showFloatHeader = true;
            if (data.length == 0) {
                this.noSearchesFindOrLoadingText;
            }
            this.savedSearchesList = this.processSaveSearchData(data);
            this.appMainService.isHideSpinner('getSaveSearchList');
        },
            (error) => {
                this.appMainService.isHideSpinner('getSaveSearchList');
            });
    }

    //date convert
    processSaveSearchData(data: SavedSearchNS.ISavedSearch[]): any {
        return data.map((response) => {
            response.createdDate = this.localDatePipe.transform(response.createdDate, 'MM/DD/YYYY');
            response.updatedDate = response.updatedDate ? this.localDatePipe.transform(response.updatedDate, 'MM/DD/YYYY') : "";
            const data = { ...response };
            return data;
        });
    }

    searchSaveSearches() {
        this.searchControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged())
            .subscribe(value => {
                this.moduleSearchValue = value.trim() ? value.trim() : '';
                this.onGlobalSearch();
            });
    }

    //#endregion **End Table Data***

    //#region ***Saved Search Actions***

    onGlobalSearch() {
        this.resetSavedSearchPagination();
        this.getSavedSeachList(1, 15);
    }

    //*Delete SavedSearch
    deleteSavedSearch(selectedSearch: SavedSearchNS.ISavedSearchOverview) {
        this.confirmationService.confirm({
            message: SavedSearchMessage.deleteconfirmationMessage,
            header: SavedSearchMessage.deleteHeader,
            icon: SavedSearchMessage.deleteCircleIcon,
            accept: () => {
                this.appMainService.isShowSpinner('deleteSavedSearch')
                this.savedSearchesService.deleteSavedSearch(selectedSearch.id)
                    .pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response) => {
                        this.appMainService.isHideSpinner('deleteSavedSearch')
                        this.messageService.add({ severity: SavedSearchMessage.success.toLowerCase(), summary: SavedSearchMessage.success, detail: SavedSearchMessage.savedSearchDeleteSuccessMsg });
                        this.backListView();
                    },
                    error => {
                        this.appMainService.isHideSpinner('deleteSavedSearch');
                        this.messageService.add({ severity: SavedSearchMessage.error.toLowerCase(), summary: SavedSearchMessage.error, detail: error?.error?.detail||'Failed to delete this saved search.' });
                    });
            },
            reject: () => {
            }
        });
    }

    backListView() {
        this.selectedSearch = null;
        this.listCols = this.listColsAll;
        this.selectedView = 'list';
        this.isLeftTableHide = false;
        this.resetSavedSearchPagination();
        this.getSavedSeachList(1, this.pageSize);
    }

    detailTabChange(event: any) {
        this.selectedTabIndex = event?.index;
    }

    resetSavedSearchPagination() {
        this.first = 0;
    }

    onStatusChanged() {
        this.backListView();
    }

    getScreenSize() {
        if (window.innerHeight <= 900) {
            this.scrHeight1 = window.innerHeight - 260 + "px";
            this.scrHeight2 = window.innerHeight - 330 + "px";
        }
    }

    onExport() {
        this.exportSavedSearch = true;
        this.resetActionValue();
    }

    showColumnSetting() {
        this.openColumnSettings = true;
        this.resetActionValue();
    }

    refreshSavedSearchQuery(){
        this.refreshSavedSearch = true;
        this.resetActionValue();
    }

    resetActionValue(){
        setTimeout(()=>{
            this.refreshSavedSearch = false;
            this.openColumnSettings = false;
            this.exportSavedSearch = false;
        },100)
    }

    //#endregion ***Action End***

    //#region ***Saved Search Chatbot***
    showChatBox() {
        if (this.selectedSearch?.id != this.app.chatBotInitializationData?.selectedSearch?.id) {
            this.app.chatBotInitializationData= {
                selectedSearch: this.selectedSearch,
                sessionId: null
            }
        }
        this.app.chatbotModule = ChatBotModule.SavedSearch;
        this.app.chatbotModules.push(ChatBotModule.SavedSearch);
        this.app.selectedChatbotWindow = ChatBotModule.SavedSearch;
        this.app.displayChatBox = true;
    }

    toggleEmojiPicker() {
        this.showEmojiPicker = true;
    }

    addQuestion(child) {
        this.chatInputMessage = child.name;
    }

    addEmoji(e) {
        this.chatInputMessage = this.chatInputMessage + e.emoji.native;
    }

    onClick(event) {
        //if (!this.container.nativeElement.contains(event.target))
        this.showEmojiPicker = false;
    }

    send() {
        this.chatMessages.push({
            message: this.chatInputMessage,
            user: this.sender
        });

        this.chatInputMessage = ""
        this.scrollToBottom()
    }

    scrollToBottom() {
        const maxScroll = this.list?.nativeElement.scrollHeight;
        this.list?.nativeElement.scrollTo({ top: maxScroll, behavior: 'smooth' });
    }

    //predict

    openPredict(){
        this.displayPredict = true;
    }
    closePredict(){
        this.displayPredict = false;
    }

    //#endregion ***Chatbot End***

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    ngAfterViewChecked() {
        this.scrollToBottom()
    }

    //add to list
    addToList(){
        this.displayAddToList = true;
    }

    cancelToList(){
        this.displayAddToList = false;
    }

    viewAddedList(){
        this.displayAddedList = true;
    }

    cancelAddedList(){
        this.displayAddedList = false;
    }

}
